import StarterKitsIcon from "../../assets/product-list-assets/starter-kits.svg";
import type { ProductListGroup } from "../../types";

export const doorAccessStarterKits: ProductListGroup = {
  id: "doorAccessStarterKits",
  title: "productListGroup.starterKits.title",
  seriesLabel: "modelCompare.seriesLabel.doorAccessStarterKits",
  icon: {
    src: StarterKitsIcon,
    width: 20,
    height: 20,
  },
};
